/**
 * GoodLeap logo for admin error emails.
 * Hosted PNG — Outlook does not render SVG / data: URIs reliably.
 * File: public/email/goodleap_logo.png (publish frontend to update).
 * Bump ?v= when replacing the PNG so mail clients bypass their image cache.
 */
export const ADMIN_ERROR_EMAIL_LOGO_SRC =
  "https://www.goodleap.dev/email/goodleap_logo.png?v=20260813b";

/** Display size (asset is 670×221). */
export const ADMIN_ERROR_EMAIL_LOGO_WIDTH = 177;
export const ADMIN_ERROR_EMAIL_LOGO_HEIGHT = 58;
